var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartsBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12250_14490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.73244 0H5.26837C4.8823 0 4.56934 0.303146 4.56934 0.677095V1.54039C4.56934 1.91434 4.8823 2.21749 5.26837 2.21749H7.73244C8.11851 2.21749 8.43147 1.91434 8.43147 1.54039V0.677095C8.43147 0.303146 8.11851 0 7.73244 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.301 11.1382H9.81165C9.4859 11.1382 9.21223 11.354 9.13464 11.646H3.86536C3.78777 11.354 3.5141 11.1382 3.18835 11.1382H2.69903C2.31299 11.1382 2 11.4414 2 11.8153V12.8986C2 13.2726 2.31299 13.5757 2.69903 13.5757H10.301C10.687 13.5757 11 13.2726 11 12.8986V11.8153C11 11.4414 10.687 11.1382 10.301 11.1382Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89882 4.95996H5.13153C5.01672 4.95996 4.9227 5.05069 4.92183 5.16207C4.91833 5.62775 4.88303 6.19075 4.83008 6.78812H8.16619C8.13212 6.09274 8.11586 5.50367 8.10852 5.15869C8.10625 5.04917 8.01206 4.95996 7.89882 4.95996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60449 8.83038H8.30882C8.25185 8.22929 8.21026 7.61737 8.18038 7.05859H4.80529C4.74902 7.64513 4.67789 8.25485 4.60449 8.83038Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56922 9.10156C4.44095 10.0784 4.31163 10.925 4.24609 11.3416H8.71184C8.5453 10.7623 8.42384 9.95301 8.33559 9.10156H4.56922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72382 10.8167H10.625C10.8886 7.18511 9.89561 6.8425 9.82885 3.99024C9.82885 2.94548 9.18941 2.60693 8.40073 2.60693H4.59871C3.81003 2.60693 3.1706 2.94548 3.1706 3.99024C3.10384 6.84267 2.11069 7.18511 2.37458 10.8179C2.39013 10.8172 2.40568 10.8167 2.42159 10.8167H3.30813C3.62671 10.8167 3.89671 10.9631 3.99108 11.1661C4.16496 10.0487 4.62964 6.90598 4.64275 5.16009C4.64467 4.90042 4.86417 4.68917 5.13207 4.68917H7.89935C8.16359 4.68917 8.38308 4.89738 8.3885 5.15315C8.41139 6.2233 8.51974 9.66379 8.97883 11.2605C9.02549 11.0104 9.3411 10.8169 9.72399 10.8169L9.72382 10.8167Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12250_14490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 17.5758,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartsBudget);
export default __webpack_public_path__ + "static/media/parts-budget.a4b5b29057ec9ecea2b416a1475312e7.svg";
export { ForwardRef as ReactComponent };